import isObject from 'lodash/isObject';

const isAnalyticsEnabled = () => isObject(window.sdlGoogleAnalyticConfig);

export default isAnalyticsEnabled;
